import script from "./HeaderRegister.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderRegister.vue?vue&type=script&setup=true&lang=js"

import "./HeaderRegister.vue?vue&type=style&index=0&id=37279b3e&lang=scss"
import "./HeaderRegister.vue?vue&type=style&index=1&id=37279b3e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37279b3e"]])

export default __exports__